import RugCardDetailedStatus from './RugCardDetailedStatus'
export default RugCardDetailedStatus
